import React from 'react'
import {Icon} from '@chakra-ui/react'

const AlertIconAlternative = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21 18V9C21 4.03 16.97 0 12 0C7.03 0 3 4.03 3 9V18H1V20H8C8 22.21 9.79 24 12 24C14.21 24 16 22.21 16 20H23V18H21ZM12 22C10.9 22 10 21.1 10 20H14C14 21.1 13.1 22 12 22ZM19 18H5V9C5 5.13 8.13 2 12 2C15.87 2 19 5.13 19 9V18Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default AlertIconAlternative
